<div class="grid">
  <div class="col-12">
    <p-card class="h-full">
      <ng-template pTemplate="title">
        <div [ngClass]="layoutService.isMobile() ? 'flex flex-column gap-2 align-items-start' : 'flex flex-1 gap-2 align-self-stretch align-items-center'">
          <div class="flex flex-1 align-items-center gap-3">
            <div style="word-break: keep-all">{{ totalRecords?.toString() + ' ' + i18n?.i18nLng()['MENUPAYOUTFILES'] + ' - ' + i18n?.i18nLng()['SEPA']}}</div>
          </div>
          <p-button [label]="i18n.i18nLng()['CLEAR']"
                    [ariaLabel]="i18n?.i18nLng()['CLEARALLFILTERS']"
                    [pTooltip]="i18n?.i18nLng()['CLEARALLFILTERS']"
                    tooltipPosition="top"
                    [outlined]="true"
                    icon="pi pi-filter-slash"
                    (click)="clearTableFilters()"/>
          <p-button icon="pi pi-download"
                    [label]="i18n?.i18nLng()['DOWNLOAD']"
                    [ariaLabel]="i18n?.i18nLng()['DOWNLOAD']"
                    [disabled]="!selectedRowData"
                    (onClick)="downloadPayoutFile('sepa')"/>
        </div>
      </ng-template>
      @if (!tableControlService.refreshTableConfig()) {
        <sps-table [tableConfig]="tableConfig()"
                   [rows]="rows"
                   [tableListProvider]="tableListProvider"
                   [parentDataProvider]="getPayoutFilesPageData"
                   [tableControlService]="tableControlService"
                   [scrollHeightOffset]="scrollHeightOffset"
                   [minScrollHeight]="minScrollHeight"
                   [freezeColumns]="true"
                   [showTogglerIcon]="false"
                   (dataFetched)="onDataFetched($event)"
                   (selectionChanged)="onSelectionChanged($event)"
                   (rowsCountChanged)="rowsCountChanged($event)"
                   (stateRestored)="onStateRestored($event)">
        </sps-table>
      }
    </p-card>
  </div>
</div>
